import environment from "@environment";
import { appSettings } from "core/config";
import { BusinessPage } from "core/constants";
import { Feature, isEnabled } from "core/features";
import { getActiveFeatures } from "core/features";
import UrlUtils from "core/lib/url-utils";

const getSiteMenu = (appendOrigin = true) => {
    const language = UrlUtils.getLanguageCode();
    const isProd = environment.production;

    const prefix = isProd ? `/business/${language}` : "#";

    const getItem = (title: string, link: string, isSelfService = true) => {
        if (!link.startsWith("#") && appendOrigin) {
            link = prefix + (isSelfService && isProd ? "/mydstv#" + link : link);
            link = (isProd ? window.location.origin : "") + link;
        }

        const subnavItems: Array<any> = [];

        return {
            title,
            link,
            subnavItems
        };
    }

    const items = [
        getItem("Dashboard", BusinessPage.dashboard)
    ];

    const show = getActiveFeatures();

    if (show.pay) {
        const item = getItem("Pay", BusinessPage.payment);
        items.push(item);
    }

    const manage = getItem("Manage", "#manage")

    if (show.statements) {
        const item = getItem("Statements and Invoices", BusinessPage.statementsAndInvoices);
        manage.subnavItems.push(item);
    }

    if (show.users) {
        const item = getItem("Users", BusinessPage.users);
        manage.subnavItems.push(item);
    }

    if (show.activityLog) {
        const item = getItem("Activity Log", BusinessPage.userActivityLogging);
        manage.subnavItems.push(item);
    }

    if (manage.subnavItems.length) {
        items.push(manage);
    }

    if (isEnabled(Feature.support)) {
        const item = getItem("Queries", BusinessPage.support);
        items.push(item);
    }

    if (!environment.production) {
        if (appSettings.isEnabled.playground) {
            const item = getItem("Demos", "");

            const links = ["modals", "icons", "styles", "date", "cards", "pager", "table", "loader"];

            links.forEach(x => {
                const subItem = getItem(x.toTitleCase(), `/demos/${x}`);
                item.subnavItems.push(subItem);
            });

            items.push(item);
        }

        if (appSettings.isEnabled.tools) {
            const item = getItem("Tools", "");

            const links = ["api tools", "http logs", "not postman"]; //"error logs", 

            links.forEach(x => {
                const subItem = getItem(x.toTitleCase(), `/tools/${x.replace(" ", "-")}`);
                item.subnavItems.push(subItem);
            });

            items.push(item);
        }
    }

    const contactUs = getItem("Contact Us", "/dstv-business-packages/contact", false);
    items.push(contactUs);

    if (appSettings.isEnabled.inbox)
    {
        const item = getItem("Inbox", BusinessPage.inbox);
        items.push(item);
    }

    return items;
}

export default getSiteMenu;
